// i18n languages are `<country><Language>` (BackofficePage): splitting them gives `be-FR` (Belarusian) or `at-DE`.
const INTL_LOCALES: Record<string, string> = {
  frFr: 'fr-FR',
  beFr: 'fr-BE',
  beNl: 'nl-BE',
  itIt: 'it-IT',
  nlNl: 'nl-NL',
  deDe: 'de-DE',
  atDe: 'de-AT',
}

export const toIntlLocale = (language: string | null | undefined): string | undefined =>
  language ? INTL_LOCALES[language] : undefined
